import { ITransaction } from '../schemas/entity_set'
import { ITransactionService, ITransactionFilter } from './transaction_service'
import { MessageBox } from '../helpers/message_box';
import { AppServices, AngularServices, Routes } from '../helpers/config_keys';
let _ = require("underscore")

class TransactionCtrl {
    types = ["Saving", "Withdrawal", "Interest"];
    records: Array<ITransaction>;
    lastFilter: ITransactionFilter;
    loading: boolean;
    deleting: boolean;

    totalRecords = 0;
    currentPage = 1;
    recordSize = 25;
    totalPages = 1;
    pageNumber = 1;

    static $inject = [AppServices.TransactionService, AngularServices.State];

    constructor(private transactionService: ITransactionService,
        private $state: angular.ui.IStateService) {
        this.start()
    }

    setStatusLabel(type: string) {
        switch (type) {
            case "Saving":
                return "label label-info";
            case "Withdrawal":
                return "label label-warning";
            case "Interest":
                return "label label-success";
            default:
                return "label label-default";
        }
    }

    addNew(type: string) {
        this.$state.go(Routes.TransactionForm, { type })
    }

    pageChanged(page: number) {
        this.currentPage = page;
        this.lastFilter.pager.page = page;
        this.loading = true
        this.transactionService.query(this.lastFilter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data;
                this.pageNumber = this.currentPage
            }
        })
    }

    fetch(filter: ITransactionFilter) {
        filter.pager = filter.pager || { page: 1, size: 25 }
        this.lastFilter = angular.copy(filter)
        this.loading = true
        this.transactionService.query(filter).then((res) => {
            this.loading = false
            if (res.success) {
                this.records = res.data
                this.totalRecords = res.total;
                this.totalPages = Math.ceil(res.total / this.recordSize);
                this.pageNumber = this.currentPage
            }
        })
    }

    delete(transaction: ITransaction) {
        MessageBox.confirm("Delete Transaction", `Are you sure you want to delete transaction ${transaction.reference}?`).then((yes) => {
            if (yes) {
                this.deleting = true
                this.transactionService.delete(transaction.id).then((res) => {
                    this.deleting = false
                    if (res.success) {
                        this.fetch(this.lastFilter)
                    }
                })
            }
        })
    }

    private start() {
        this.fetch(<ITransactionFilter>{})
    }
}

export { TransactionCtrl }


// WEBPACK FOOTER //
// ./app/transactions/transactions_ctrl.ts